import { render } from "./ClientCargaMasivaClientes.vue?vue&type=template&id=2679364d&scoped=true"
import script from "./ClientCargaMasivaClientes.vue?vue&type=script&lang=js"
export * from "./ClientCargaMasivaClientes.vue?vue&type=script&lang=js"

import "./ClientCargaMasivaClientes.vue?vue&type=style&index=0&id=2679364d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2679364d"]])

export default __exports__